import React from 'react';
import PropTypes from 'prop-types';
import {AppBar, Toolbar, Slide} from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import {makeStyles} from '@mui/styles';
import SideNav from './SideNav';

const useStyles = makeStyles((theme) => ({
  navBar: {
    background: '#000000',
    paddingRight: '0px !important',
    height: '80px',
    color: 'white',
  },

  header: {
    fontFamily: 'Bebas Neue !important',
    fontWeight: 'bold !important',
    fontSize: '28px',
    color: 'white',
    textDecoration: 'none',
  },
}));

export default function Header(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <HideOnScroll {...props}>
        <AppBar>
          <Toolbar className={classes.navBar}>
            <SideNav />
            <a className={classes.header} href="/">
              Frank Luna
            </a>
            <img
              src="/logo192.png"
              alt="Frank Luna Logo"
              className="landing-page-logo"
            />
          </Toolbar>
        </AppBar>
      </HideOnScroll>
    </React.Fragment>
  );
}

export function HideOnScroll(props) {
  const {children} = props;

  const trigger = useScrollTrigger({
    target: window,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.node.isRequired,
};
